import html2canvas from 'html2canvas';
import { putBlobToS3 } from '../fileUpload';

interface IProps {
  divElementId: string;
  s3UploadUrl: string;
  onComplete: (sccess: boolean) => void;
}

const createAndUploadScreenshot = async ({
  divElementId,
  s3UploadUrl,
  onComplete,
}: IProps) => {
  const divElement = document.getElementById(divElementId);
  if (!divElement) {
    onComplete(false);
    return;
  }
  const canvas = await html2canvas(divElement, {
    scale: 2,
    useCORS: true,
    logging: false,
  });

  const blobCallback = async (blob: Blob | null) => {
    if (blob === null) {
      onComplete(false);
      return;
    }
    await putBlobToS3(s3UploadUrl, blob)
      .then(() => onComplete(true))
      .catch(() => onComplete(false));
  };

  canvas.toBlob(blobCallback, 'image/png');
};

export default createAndUploadScreenshot;
